export default {
  dbName: "ipdc",
  version: 1,
  tables: [{
      tableName: "conversation", // 会话表
      option: {
        keyPath: "id"
      },
      indexs: [{
        key: "id",
          option: {
            unique: true
          }
      },
        {
          key: "time", 
        }
      ]
    },
   {
     tableName: "chartlist", // *消息表
     option: {
       keyPath: "id"
     },
     indexs: [{
         key: "id",
         option: {
           unique: true
         }
       },
       {
         key: "list"
       },
        
      
     ]
   }


  ]
}
